<template>
    <div class="invest-dark py-5">
    <div class="container">
      <div class="row flex-lg-row-reverse align-items-center">
        <div class="col-12 col-sm-8 col-lg-6">
          <img
            src="@/images/invest/crosswork.png"
            class="d-block mx-lg-auto img-fluid w-100"
            loading="lazy"
          />
        </div>
        <div class="col-lg-6">
          <h1 class="py-4 fw-bold display-5 text-center">
            Partnered with CrossWork
          </h1>
          <p class="lead mb-4 text-center">
            In preparation for a liquidity event we have partnered with
            CrossWork.us a leading pre- IPO group with a track record of many
            pre-IPO success stories and multiple executives that have taken
            companies public
          </p>
        </div>
      </div>
    </div>
  </div>
</template>